import { Injectable } from '@angular/core';
import { Currency } from '../currency';

@Injectable({
  providedIn: 'root'
})
export class CurrencyService {

  currencies: Currency[] = [];

  constructor() { }
}
